const getDesignTokens = (mode => ({
  palette: {
    mode,
    primary: {
        main: mode === 'light' ? '#222' : '#fff'
    },
    secondary: {
        main: mode === 'light' ? '#000' : '#fff'
    },
    background: {
        default: mode === 'light' ? '#fff' : '#333'
    }
  }
}));

export default getDesignTokens;
